/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'stack': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M23.06 1.22c.6-.3 1.29-.3 1.88 0l20.9 10.46a2.1 2.1 0 0 1 0 3.74l-20.9 10.45c-.6.3-1.29.3-1.88 0L2.16 15.42a2.1 2.1 0 0 1 0-3.74l20.9-10.46zM7.76 13.55L24 21.66l16.23-8.11L24 5.43 7.77 13.55z"/><path pid="1" d="M1.22 33.52a2.1 2.1 0 0 1 2.8-.94l19.98 10 19.97-10a2.1 2.1 0 0 1 1.87 3.74l-20.9 10.46c-.6.3-1.29.3-1.88 0L2.16 36.32a2.1 2.1 0 0 1-.94-2.8z"/><path pid="2" d="M4.03 22.13a2.1 2.1 0 1 0-1.87 3.74l20.9 10.45c.6.3 1.29.3 1.88 0l20.9-10.45a2.1 2.1 0 0 0-1.87-3.74L24 32.12 4.03 22.13z"/>'
  }
})
